<!--
  Disclosure modal. Read-only: there is no accept control here by design — accepting
  happens on the banner, so that opening the text can never be mistaken for consenting to it.
-->
@if (visible) {
  <div class="disclosure-modal-backdrop" (click)="close()"></div>

  <div class="disclosure-modal"
       role="dialog"
       aria-modal="true"
       [attr.aria-label]="title"
       data-testid="disclosure-modal">

    <div class="disclosure-modal-header">
      <h5 class="disclosure-modal-title">{{ title }}</h5>
      <button type="button"
              class="disclosure-modal-close"
              (click)="close()"
              [attr.aria-label]="'Close' | translate">&times;</button>
    </div>

    <div class="disclosure-modal-body" data-testid="disclosure-modal-body">
      @if (loading) {
        <p class="disclosure-modal-loading" translate>Loading...</p>
      } @else {
        <app-markdown-view [markdown]="body"></app-markdown-view>
      }
    </div>

    <div class="disclosure-modal-footer">
      <button type="button"
              class="btn btn-primary"
              (click)="close()"
              data-testid="disclosure-done">
        <span translate>Done</span>
      </button>
    </div>

  </div>
}
